var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.368 27.773H17.38V11.571h6.348V5h3.061v6.57H30v3.286h-3.21v9.707h3.135v3.21h-6.197V14.856h-3.36v12.917zM17.38 8.136V5h3.212v3.136h-3.21zm-6.495-3.061H2v22.773h10.005c2.15 0 3.286-2.539 3.584-3.808v-5.675c0-.776-1.594-1.717-2.39-2.09.448-.3 1.344-1.135 1.344-2.09V9.106c0-2.748-2.44-3.833-3.659-4.032zm-5.6 9.557V8.36h4.78c.472 0 1.433.254 1.492 1.27.06 1.015.025 3.01 0 3.882-.05.373-.418 1.12-1.493 1.12H5.285zm0 3.584v6.272h5.824c.497-.15 1.493-.717 1.493-1.792v-2.912c-.1-.523-.538-1.568-1.494-1.568H5.284z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBit);
export default __webpack_public_path__ + "static/media/BIT.d1d1229c8842b3a3f42fe394d3de26c2.svg";
export { ForwardRef as ReactComponent };